// import external dependencies
import 'jquery';
import 'modaal';
import 'slick-carousel/slick/slick.min';
import 'jquery-match-height';
import 'motion-ui/dist/motion-ui';

// Import everything from autoload
import './autoload/_foundation.js'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import file from './routes/file';


/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
  file,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());
